import type { OneStoreViewRow } from "@CommonTypes/merchflow/OneStoreView";

type StorePogStatus = NonNullable<OneStoreViewRow["store_pog"]>["status"];

export const MAX_PDF_STATUS_POLLS = 25;

export const isStorePogInProgress = (status: StorePogStatus): boolean =>
  status === "NOT_STARTED" || status === "POGGER_IN_PROGRESS" || status === "UPDATE_IN_PROGRESS";

export const hasPendingPdfExport = (stores: OneStoreViewRow[]): boolean =>
  stores.some(
    (store) =>
      store.store_pog?.pdf_export?.status === "NOT_STARTED" ||
      store.store_pog?.pdf_export?.status === "IN_PROGRESS",
  );

export const getStoresPollingDecision = (
  stores: OneStoreViewRow[],
  includePdfPolling: boolean,
  forcePdfRefresh = false,
): { shouldPoll: boolean; countsTowardPdfBudget: boolean } => {
  const countsTowardPdfBudget =
    includePdfPolling && (forcePdfRefresh || hasPendingPdfExport(stores));

  return {
    shouldPoll:
      countsTowardPdfBudget ||
      stores.some((store) => store.store_pog && isStorePogInProgress(store.store_pog.status)),
    countsTowardPdfBudget,
  };
};
